module.exports = new __parcel__URL__("bronze_pack.dfa60ce3.png").toString();